<style lang="stylus">
  .takeCardsWrapper {
    width: 90vw;
    border-radius: 0.2rem;
    .title {
      font-size: 0.43rem;
      padding: 0.2rem;
      color: #f13b3a;
      background: #eee;
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        font-weight: bold;
        margin-left: 0.15rem;
      }
    }
    .content {
      min-height: 30vh;
      max-height: 70vh;
      font-size: 0.37rem;
      padding: 0 0.2rem 0.3rem 0.2rem;
      overflow-y: auto;
    }
    .footer {
      border-bottom-left-radius: 0.2rem;
      border-bottom-right-radius: 0.2rem;
      padding: 10px;
      button {
        border-radius: 4px;
      }
    }
  }
</style>
<template>
  <mt-popup v-model="visible" class="takeCardsWrapper" :closeOnClickModal="false" pop-transition="popup-fade">
    <div class="title">
      <gift-icon></gift-icon>
      <span style="font-size: 0.35rem">今日福利</span>
      <span>下单立减</span>
    </div>
    <div class="content">
      <template v-for="activity in takeCardsArr">
        <take-card-item v-for="(card, index) in activity.cards" :key="card.id" :card="card"></take-card-item>
      </template>
    </div>
    <div class="footer">
      <mt-button type="danger" size="large" @click.stop="takeCards" :disabled="submitting">
        {{submitting ? '正在领取...' : '立即领取'}}
      </mt-button>
    </div>
  </mt-popup>
</template>
<script>
  import {mapState, mapMutations} from 'vuex';
  import giftIcon from 'src/components/icons/Gift';
  import takeCardItem from 'src/components/common/TakeCardItem';
  import {takeActivityCards, getUserIdentity} from 'src/components/api/interface-hhy';
  /**
   * 领券
   */
  export default {
    // 使用其它组件
    components: {
      giftIcon,
      takeCardItem
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    // 属性
    data () {
      return {
        submitting: false
      }
    },
    // 计算属性
    computed: {
      ...mapState(['takeCardsArr'])
    },
    watch: {},
    // 生命周期函数
    created () {},
    mounted () {},
    methods: {
      ...mapMutations(['setTakeCardsModalVisible', 'addTakeCardsBranchIds']),
      // 领券卡券
      takeCards () {
        if (this.submitting) {
          return false;
        }
        this.submitting = true;
        let activityArr = [];
        for (let activity of this.takeCardsArr) {
          let cardIdArr = [];
          for (let card of activity.cards) {
            cardIdArr.push({id: card.id, send_count: card.num});
          }
          activityArr.push({
            activityId: activity.activity_id,
            cardsArr: cardIdArr
          });
        }
        takeActivityCards(activityArr).then(res => {
          this.submitting = false;
          this.$toast('领取成功');
          this.setTakeCardsModalVisible(false);
          this.addTakeCardsBranchIds(getUserIdentity('branchId'));
        }).catch(() => {
          this.submitting = false;
          this.$toast('领取失败');
        });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/TakeCardsModal.vue